import { L10n as params } from "./_params.js"
import { string, toAst } from "./lib/string.js"

export const L10n = {
  params,
  lib: { string, toAst },
}
